const EyerBlockSvg = (props: any) => {
  return (
    <svg
      width="20"
      height="18"
      viewBox="0 0 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M17.407 14.993L18.707 16.293C19.098 16.684 19.098 17.316 18.707 17.707C18.512 17.902 18.256 18 18 18C17.744 18 17.488 17.902 17.293 17.707L14.586 15L14 14.414L12.655 13.069L12.586 13L10.0837 10.4977C10.056 10.4992 10.0281 10.5 10 10.5C9.173 10.5 8.5 9.827 8.5 9C8.5 8.97192 8.50078 8.94401 8.50231 8.91631L5.283 5.697L3.532 3.946L1.293 1.707C0.902 1.316 0.902 0.683998 1.293 0.292998C1.684 -0.0980018 2.316 -0.0980018 2.707 0.292998L4.42 2.006L5.885 3.471L9.91631 7.50231C9.94401 7.50077 9.97192 7.5 10 7.5C10.827 7.5 11.5 8.173 11.5 9C11.5 9.02808 11.4992 9.05598 11.4977 9.08369L15.414 13L17.407 14.993ZM6.5928 2.7642L9.3898 5.5612C9.5888 5.5262 9.7908 5.5002 9.9998 5.5002C11.9298 5.5002 13.4998 7.0702 13.4998 9.0002C13.4998 9.2092 13.4738 9.4112 13.4388 9.6102L16.1208 12.2932L16.9548 13.1272C18.4768 11.7392 19.4528 10.2202 19.8678 9.4972C20.0438 9.1892 20.0438 8.8102 19.8678 8.5022C19.2298 7.3902 15.7058 1.8162 9.7298 2.0032C8.5458 2.0342 7.4738 2.2892 6.5018 2.6742L6.5928 2.7642ZM11.948 13.7771L13.293 15.1211L13.498 15.3261C12.526 15.7111 11.455 15.9661 10.271 15.9961C10.189 15.9991 10.106 16.0001 10.025 16.0001C4.162 16.0001 0.762 10.5951 0.132 9.4971C-0.044 9.1891 -0.044 8.8101 0.132 8.5021C0.547 7.7801 1.523 6.2611 3.045 4.8731L4.576 6.4051L6.562 8.3901C6.526 8.5891 6.5 8.7911 6.5 9.0001C6.5 10.9301 8.07 12.5001 10 12.5001C10.209 12.5001 10.411 12.4741 10.61 12.4381L11.879 13.7071L11.948 13.7771Z"
        fill="#343C44"
      />
    </svg>
  )
}

export default EyerBlockSvg
